/*
✅ "Continue"
✅ Added "Well done completing the learning session today!"
✅ Displayed a high-five React icon (FaRegHandSpock) above the messageConti
*/


import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import TrueFalsePostPSCompletionFeedBackQuestion from "./TrueFalsePostPSCompletionFeedBackQuestion";
import { getPracticeSessionQuestions } from "../datafetch/PracticeSessionService";
import { FaRegHandSpock } from "react-icons/fa"; // ✅ Import high-five icon

const PracticeSessionPostCompletionFeedBackQuestion = ({ lessonId, topicId, onComplete }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isSessionComplete, setIsSessionComplete] = useState(false);

  const db = getFirestore();
  const auth = getAuth();

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    const fetchedQuestions = await getPracticeSessionQuestions(lessonId);
    
    console.log(`✅ Fetched ${fetchedQuestions.length} questions for lessonId: ${lessonId}`);

    if (fetchedQuestions.length > 0) {
      setQuestions(fetchedQuestions);
      setIsDataLoaded(true);
    }
  };

  // ✅ Move to the next question or mark session as complete
  const handleNextQuestion = async () => {
    console.log(`✅ Moving to next question. Current index: ${currentQuestionIndex}`);

    if (currentQuestionIndex + 1 < questions.length) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    } else {
      //console.log("✅ No more questions, session marked as complete.");
      await logPracticeSession();
      setIsSessionComplete(true);
    }
  };

  // ✅ Log practice session in Firestore
  const logPracticeSession = async () => {
    try {
      const user = auth.currentUser;
      if (!user) {
        console.warn("⚠️ No user logged in, skipping Firestore updates.");
        return;
      }

      const userId = user.uid;

      await addDoc(collection(db, "userpracticesessions"), {
        date: new Date(),
        lessonid: lessonId,
        userid: userId,
        channel: "1",  // Web
        sessiontype:"practice",
        challengeid: topicId || "N/A",
      });

      //console.log("✅ Logged practice session in Firestore.");
    } catch (error) {
      console.error("❌ Error logging practice session:", error);
    }
  };

  // ✅ Ensure onComplete is called only when session is complete
  const handleCompleteSession = () => {
    if (typeof onComplete === "function") {
      //console.log("✅ Navigating to Course Landing...");
      onComplete();
    } else {
      console.error("❌ onComplete is not a function");
    }
  };

  return (
    <div style={{ padding: "20px", backgroundColor: "black", color: "white", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      {isDataLoaded && questions.length > 0 ? (
        <>
          {/* ✅ Show questions until all are answered */}
          {!isSessionComplete ? (
            <TrueFalsePostPSCompletionFeedBackQuestion
              key={currentQuestionIndex} // ✅ Force re-render when index changes
              question={questions[currentQuestionIndex]}
              onNext={handleNextQuestion}
            />
          ) : (
            <>
              {/* ✅ High-five icon and completion message */}
              <FaRegHandSpock size={40} color="#FF7C24" style={{ marginBottom: "10px" }} />
              <p style={{ fontSize: "20px", fontWeight: "bold", color: "white", textAlign: "center" }}>
                Well done completing the learning session today!
              </p>

              {/* ✅ Updated button text to "Continue" */}
              <button
                onClick={handleCompleteSession}
                style={{
                  backgroundColor: "#FF7C24",
                  color: "white",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  border: "none",
                  marginTop: "20px",
                  cursor: "pointer",
                }}
              >
                Continue
              </button>
            </>
          )}
        </>
      ) : (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "16px", color: "white" }}>Loading feedback questions...</p>
        </div>
      )}
    </div>
  );
};

export default PracticeSessionPostCompletionFeedBackQuestion;








// import React, { useState, useEffect } from "react";
// import { getFirestore, collection, addDoc } from "firebase/firestore";
// import { getAuth } from "firebase/auth";
// import MultipleChoicePSQuestion from "./MultipleChoicePSQuestion";
// import MultipleChoiceChartPSQuestion from "./MultipleChoiceChartPSQuestion";
// import TrueFalsePostPSCompletionFeedBackQuestion from "./TrueFalsePostPSCompletionFeedBackQuestion";
// import TrueFalseChartPSQuestion from "./TrueFalseChartPSQuestion";
// import MatchTheFollowingPSQuestion from "./MatchTheFollowingPSQuestion";
// import MatchTheFollowingChartPSQuestion from "./MatchTheFollowingChartPSQuestion";
// import { getPracticeSessionQuestions } from "../datafetch/PracticeSessionService";

// const PracticeSessionPostCompletionFeedBackQuestion = ({ lessonId, topicId, onComplete }) => {
//   const [questions, setQuestions] = useState([]);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [isDataLoaded, setIsDataLoaded] = useState(false);

//   const db = getFirestore();
//   const auth = getAuth();

//   useEffect(() => {
//     loadQuestions();
//   }, []);

//   const loadQuestions = async () => {
//     const fetchedQuestions = await getPracticeSessionQuestions(lessonId);
    
//     console.log(`✅ Fetched ${fetchedQuestions.length} questions for lessonId: ${lessonId}`);

//     if (fetchedQuestions.length > 0) {
//       setQuestions(fetchedQuestions);
//       setIsDataLoaded(true);
//     } else {
//       onComplete();
//     }
//   };

//   // ✅ Move to the next question or complete the session
//   const handleNextQuestion = async () => {
//     console.log(`✅ Moving to next question. Current index: ${currentQuestionIndex}`);

//     if (currentQuestionIndex + 1 < questions.length) {
//       setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
//     } else {
//       //console.log("✅ No more questions, finishing practice session.");
//       await logPracticeSession();
//       onComplete();
//     }
//   };

//   // ✅ Log practice session in Firestore
//   const logPracticeSession = async () => {
//     try {
//       const user = auth.currentUser;
//       if (!user) {
//         console.warn("⚠️ No user logged in, skipping Firestore updates.");
//         return;
//       }

//       const userId = user.uid;

//       await addDoc(collection(db, "userpracticesessions"), {
//         date: new Date(),
//         lessonid: lessonId,
//         userid: userId,
//         channel: "1",  // Web
//         challengeid: topicId || "N/A",
//       });

//       //console.log("✅ Logged practice session in Firestore.");
//     } catch (error) {
//       console.error("❌ Error logging practice session:", error);
//     }
//   };

//   const currentQuestion = questions[currentQuestionIndex];

//   return (
//     <div style={{ padding: "20px", backgroundColor: "black", color: "white", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
//       {isDataLoaded ? (
//         <>
//           {questions.length > 0 && currentQuestionIndex < questions.length && (
//             <>
//               {["1", "4"].includes(currentQuestion.questiontypeid) && (
//                 <MultipleChoicePSQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//               {["5.1", "5.4", "6.1", "6.4", "7.1", "7.4", "6-2.1", "6-2.4"].includes(currentQuestion.questiontypeid) && (
//                 <MultipleChoiceChartPSQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//               {currentQuestion.questiontypeid === "2" && (
//                 <TrueFalsePostPSCompletionFeedBackQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//               {["5.2", "6.2", "7.2", "6-2.2"].includes(currentQuestion.questiontypeid) && (
//                 <TrueFalseChartPSQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//               {currentQuestion.questiontypeid === "3" && (
//                 <MatchTheFollowingPSQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//               {["5.3", "6.3", "6-2.3", "7.3"].includes(currentQuestion.questiontypeid) && (
//                 <MatchTheFollowingChartPSQuestion question={currentQuestion} onNext={handleNextQuestion} />
//               )}
//             </>
//           )}
//         </>
//       ) : (
//         <div style={{ textAlign: "center" }}>
//           <p style={{ fontSize: "16px", color: "white" }}>Loading feedback questions...</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PracticeSessionPostCompletionFeedBackQuestion;
